"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _get = require("../../utils/get");

var _updateByIdentifier = require("../../tags/values/update-by-identifier");

var _ContextProps = require("../../types/ContextProps");

var _Identifiers = require("../../types/Identifiers");

var _keysMetaData;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { keys.push.apply(keys, Object.getOwnPropertySymbols(object)); } if (enumerableOnly) keys = keys.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var IDs = {
  SITE_NAME: 'site.name',
  BUSINESS_NAME: 'site.businessName',
  INDEX_PAGE: 'page.index',
  ID: 'product.id',
  SKU: 'product.sku',
  NAME: 'product.name',
  DESCRIPTION: 'product.description',
  PRICE: 'product.price',
  CURRENCY: 'product.currency',
  TYPE: 'product.type',
  WEIGHT: 'product.weight',
  AVAILABILITY: 'product.availability',
  SLUG: 'product.slug',
  IMAGE_URL: 'product.image.url',
  IMAGE_WIDTH: 'product.image.width',
  IMAGE_HEIGHT: 'product.image.height',
  IMAGE_ALT: 'product.image.alt',
  THUMBNAIL_URL: 'product.thumbnail.url',
  THUMBNAIL_WIDTH: 'product.thumbnail.width',
  THUMBNAIL_HEIGHT: 'product.thumbnail.height',
  THUMBNAIL_ALT: 'product.thumbnail.alt',
  PRODUCT_PAGE_URL: 'product.productPage.url',
  PRODUCT_PAGE_BASE_URL: 'product.productPage.baseUrl'
};
var keysMetaData = (_keysMetaData = {}, _keysMetaData[IDs.SITE_NAME] = {
  userVisibility: true
}, _keysMetaData[IDs.BUSINESS_NAME] = {
  userVisibility: true
}, _keysMetaData[IDs.INDEX_PAGE] = {
  userVisibility: false
}, _keysMetaData[IDs.ID] = {
  userVisibility: false
}, _keysMetaData[IDs.SKU] = {
  userVisibility: true
}, _keysMetaData[IDs.NAME] = {
  userVisibility: true
}, _keysMetaData[IDs.DESCRIPTION] = {
  userVisibility: true
}, _keysMetaData[IDs.PRICE] = {
  userVisibility: true
}, _keysMetaData[IDs.CURRENCY] = {
  userVisibility: true
}, _keysMetaData[IDs.TYPE] = {
  userVisibility: false
}, _keysMetaData[IDs.WEIGHT] = {
  userVisibility: false
}, _keysMetaData[IDs.AVAILABILITY] = {
  userVisibility: true
}, _keysMetaData[IDs.SLUG] = {
  userVisibility: false
}, _keysMetaData[IDs.IMAGE_URL] = {
  userVisibility: false
}, _keysMetaData[IDs.IMAGE_WIDTH] = {
  userVisibility: false
}, _keysMetaData[IDs.IMAGE_HEIGHT] = {
  userVisibility: false
}, _keysMetaData[IDs.IMAGE_ALT] = {
  userVisibility: false
}, _keysMetaData[IDs.THUMBNAIL_URL] = {
  userVisibility: false
}, _keysMetaData[IDs.THUMBNAIL_WIDTH] = {
  userVisibility: false
}, _keysMetaData[IDs.THUMBNAIL_HEIGHT] = {
  userVisibility: false
}, _keysMetaData[IDs.THUMBNAIL_ALT] = {
  userVisibility: false
}, _keysMetaData[IDs.PRODUCT_PAGE_URL] = {
  userVisibility: true
}, _keysMetaData);
var _default = {
  IDs: IDs,
  getData: function getData(item) {
    var _ref;

    return _ref = {}, _ref[IDs.SITE_NAME] = (0, _get.get)(item, "context." + _ContextProps.CONTEXT_PROPS.SITE_NAME), _ref[IDs.BUSINESS_NAME] = (0, _get.get)(item, "context." + _ContextProps.CONTEXT_PROPS.BUSINESS_NAME), _ref[IDs.INDEX_PAGE] = (0, _get.getRawValue)(item, "context." + _ContextProps.CONTEXT_PROPS.INDEX_PAGE), _ref[IDs.ID] = (0, _get.get)(item, 'product.id'), _ref[IDs.SKU] = (0, _get.get)(item, 'product.sku'), _ref[IDs.NAME] = (0, _get.get)(item, 'product.name'), _ref[IDs.DESCRIPTION] = (0, _get.get)(item, 'product.description'), _ref[IDs.PRICE] = (0, _get.get)(item, 'product.price.discountedPrice') > 0 ? "" + (0, _get.get)(item, 'product.price.discountedPrice') : "" + (0, _get.get)(item, 'product.price.price'), _ref[IDs.CURRENCY] = "" + (0, _get.get)(item, 'product.price.currency'), _ref[IDs.TYPE] = (0, _get.get)(item, 'product.productType'), _ref[IDs.WEIGHT] = (0, _get.get)(item, 'product.weight'), _ref[IDs.AVAILABILITY] = "" + (0, _get.get)(item, 'product.stock.inStock') === 'true' ? 'https://schema.org/InStock' : 'https://schema.org/OutOfStock', _ref[IDs.SLUG] = (0, _get.get)(item, 'product.slug'), _ref[IDs.IMAGE_URL] = (0, _get.get)(item, 'product.media.mainMedia.image.url'), _ref[IDs.IMAGE_WIDTH] = (0, _get.get)(item, 'product.media.mainMedia.image.width'), _ref[IDs.IMAGE_HEIGHT] = (0, _get.get)(item, 'product.media.mainMedia.image.height'), _ref[IDs.IMAGE_ALT] = (0, _get.get)(item, 'product.media.mainMedia.image.alt'), _ref[IDs.THUMBNAIL_URL] = (0, _get.get)(item, 'product.media.mainMedia.thumbnail.url'), _ref[IDs.THUMBNAIL_WIDTH] = (0, _get.get)(item, 'product.media.mainMedia.thumbnail.width'), _ref[IDs.THUMBNAIL_HEIGHT] = (0, _get.get)(item, 'product.media.mainMedia.thumbnail.height'), _ref[IDs.THUMBNAIL_ALT] = (0, _get.get)(item, 'product.media.mainMedia.thumbnail.alt'), _ref[IDs.PRODUCT_PAGE_URL] = (0, _get.get)(item, 'product.productPageUrl.path'), _ref[IDs.PRODUCT_PAGE_BASE_URL] = (0, _get.get)(item, 'product.productPageUrl.base').replace('/product-page', ''), _ref;
  },
  getLegacySeoBlob: function getLegacySeoBlob(item) {
    var tags = (0, _updateByIdentifier.updateValueByIdentifier)([], _Identifiers.IDENTIFIERS.TITLE, (0, _get.get)(item, 'legacySeoData.title'));
    tags = (0, _updateByIdentifier.updateValueByIdentifier)(tags, _Identifiers.IDENTIFIERS.DESCRIPTION, (0, _get.get)(item, 'legacySeoData.description'));
    return {
      tags: tags
    };
  },
  getBiData: function getBiData(item) {
    return {
      id: (0, _get.get)(item, 'product.id'),
      name: (0, _get.get)(item, 'product.name')
    };
  },
  getKeys: function getKeys() {
    return Object.values(IDs).map(function (key) {
      return _objectSpread({
        key: key
      }, keysMetaData[key]);
    });
  }
};
exports["default"] = _default;